import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { ModalBody, ModalFooter } from '../modal-helpers';
import './ConfirmDowngradePromoModal.pcss';
import PromotionsCRUDActions from '@mm/state/actions/PromotionsCRUDActions';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { OpenConfirmDowngradePromoModalParams } from '@mm/state/modules/modalsState/actions';
import { ModalInstanceProps } from '../interfaces';

type OuterProps = OpenConfirmDowngradePromoModalParams & ModalInstanceProps;

type InnerProps = ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  disconnectCode: (id: number, companyId: number, facebookPageId: number) =>
    dispatch(PromotionsCRUDActions.disconnect(id, companyId, facebookPageId)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

const ConfirmDowngradePromoModal = (props: Props) => {
  const { closeModal, page, disconnectCode, companyId } = props;

  const onConfirmDisconnect = async () => {
    if (page && page.redemption) {
      await disconnectCode(page.redemption.id, companyId, page.id);
    }

    closeModal();
  };

  return (
    <div className="confirm-downgrade-promo-modal">
      <ModalBody>
        <div className="confirm-downgrade-promo-modal__header">
          Are you sure you want to disconnect this promotional code?
        </div>
      </ModalBody>

      <ModalFooter className="confirm-downgrade-promo-modal__footer">
        <Button
          className="confirm-downgrade-promo-modal__button"
          onClick={onConfirmDisconnect}
          yellow
        >
          Apply
        </Button>

        <Button
          className="confirm-downgrade-promo-modal__button"
          onClick={closeModal}
          invert
        >
          Cancel
        </Button>
      </ModalFooter>
    </div>
  );
};

export default enhance(ConfirmDowngradePromoModal);
